export default __webpack_public_path__ + "b7553bd6aa024de862bbf1b7065a68a0.svg";